export enum HeaderVariant {
  primary = 'primary',
  secondary = 'secondary',
  blackfriday = 'black-friday'
}

export enum HeaderHeroType {
  heroRed = 'hero-red',
  heroPlum = 'hero-plum',
  heroBlack = 'hero-black',
}
